import React from 'react';

import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';

import {KpiError} from './kpiWidgetErrors';
import LastUpdateInfo from './LastUpdateInfo';
import './ChartWidgetContent.scss';
import EditModeOverlay from '../../../EditModeOverlay';

type Props = {
	loading: boolean;
	title: string;
	kpiErrorMessage: string | null | undefined;
	kpiNames: string;
	containerRef: React.Ref<any>;
	footerLabel?: string | null | undefined;
	dashboardTime?: number | null | undefined;
	editMode: boolean;
	lastUpdate?: number | null | undefined;
};

const ChartWidgetContent = ({
	loading,
	title,
	kpiErrorMessage,
	kpiNames,
	containerRef,
	footerLabel,
	dashboardTime,
	editMode,
	lastUpdate
}: Props) => {
	return (
		<SpinnerContainer show={loading && !kpiErrorMessage} size={30} data-testid="spinner-wrapper">
			<div className="dash-box kpi-chart-widget">
				<div className="dash-box-head-container" data-testid="widget-title">
					<div className="dash-box-head">
						<span>{title}</span>
					</div>
				</div>
				{kpiErrorMessage ? (
					<KpiError kpiName={kpiNames} errorMessage={kpiErrorMessage} />
				) : (
					<div className="kpi-chart-container">
						<div ref={containerRef} className="kpi-chart" />
					</div>
				)}
				{footerLabel && (
					<div className="dash-box-footline">
						<div>{footerLabel}</div>
						{!dashboardTime && <LastUpdateInfo time={lastUpdate} />}
					</div>
				)}
				{editMode && <EditModeOverlay />}
			</div>
		</SpinnerContainer>
	);
};

export default ChartWidgetContent;
